<div class="bg-white rounded-lg shadow-md mx-auto ticket-table-container">
  <p-table 
    #dataTable
    [value]="filteredTickets"
    [paginator]="true"
    [rows]="rowsPerPage"
    [rowsPerPageOptions]="[5, 10, 20, 50, 100]"
    [showFirstLastIcon]="true"
    [showPageLinks]="true"
    [showCurrentPageReport]="true"
    [showJumpToPageDropdown]="true"
    [scrollable]="true"
    scrollHeight="flex"
    scrollDirection="both"
    showGridlines="horizontal"
    styleClass="p-datatable-gridlines p-datatable-striped rounded-lg"
    resizableColumns="true"
    columnResizeMode="expand"
    dataKey="id">
    
    <ng-template pTemplate="caption">
      <div class="flex items-center justify-between p-6 bg-amber-50 border rounded-lg border-amber-200 backdrop-blur-sm">
        <div class="flex items-center gap-3">
          <button 
            class="group relative px-3 py-2 bg-green-50 text-green-500 rounded hover:bg-green-100 active:bg-green-100 transition-all duration-300 flex items-center gap-3 shadow-lg hover:shadow-xl transform hover:-translate-y-1 hover:scale-105 font-semibold text-sm border border-green-500/20" 
            (click)="dataTable.clear()">
            <i class="pi pi-filter-slash text-sm group-hover:rotate-12 transition-transform duration-300"></i> 
            <span class="tracking-wide">Clear Filters</span>
            <div class="absolute inset-0 rounded-xl bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </button>
        </div>

        <div class="flex items-center w-96 relative group">
          <div class="relative w-full">
            <div class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none z-10">
              <i class="pi pi-search text-slate-400 text-sm group-focus-within:text-blue-500 transition-colors duration-300"></i>
            </div>
            <input 
              type="text" 
              class="w-full pl-12 pr-12 py-3.5 border-2 border-slate-200/60 rounded-xl focus:outline-none focus:ring-4 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-300 bg-white/80 backdrop-blur-sm shadow-lg hover:shadow-xl text-sm placeholder-slate-400 font-medium group-hover:border-slate-300" 
              [(ngModel)]="searchValue"
              (input)="onGlobalFilter($event)" 
              placeholder="Search across all records..." />
            <div *ngIf="searchValue" class="absolute inset-y-0 right-0 pr-4 flex items-center z-10">
              <button 
                (click)="searchValue = ''; dataTable.filterGlobal('', 'contains')" 
                class="p-1.5 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-all duration-200 group">
                <i class="pi pi-times text-sm group-hover:rotate-90 transition-transform duration-200"></i>
              </button>
            </div>
            <div class="absolute inset-0 rounded-xl bg-gradient-to-r from-blue-500/5 to-purple-500/5 opacity-0 group-focus-within:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr class="bg-gray-100 m-0 p-0">
        <th class="px-4 py-3 text-center text-sm font-medium text-gray-700 bg-gray-100">
          Action
        </th>
        <th 
          *ngFor="let col of columns" 
          class="px-4 py-3 text-left text-sm font-medium text-gray-700 bg-gray-100" 
          pResizableColumn>
          <span class="text-wrap text-wrap-break">{{ col.header }}</span>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-ticket let-rowIndex="rowIndex">
      <tr class="border-b border-gray-200 hover:bg-gray-50 transition-colors duration-150">
        <!-- Action Column -->
        <td class="px-4 py-3 text-center">
          <button 
            mat-button 
            [matMenuTriggerFor]="actionsMenu" 
            class="action-button">
            Actions
          </button>
          <mat-menu #actionsMenu="matMenu" class="shadow-lg border border-gray-200 bg-gray-100 rounded-md">
            <!-- <button 
              (click)="viewEvent.emit(ticket)" 
              mat-menu-item 
              class="flex items-center justify-start gap-3 px-4 py-3 w-full hover:bg-blue-50 text-blue-600 hover:text-blue-800 transition-colors duration-200">
              <i class="fa-solid fa-eye text-blue-500 w-4 h-4 flex-shrink-0"></i>
              <span class="text-sm font-medium mr-2 ml-2">View</span>
            </button> -->
            <button 
              (click)="viewStatusEvent.emit(ticket)" 
              mat-menu-item 
              class="flex items-center justify-start gap-3 px-4 py-3 w-full hover:bg-purple-50 text-purple-600 hover:text-purple-800 transition-colors duration-200">
              <i class="fa-solid fa-history text-purple-500 w-4 h-4 flex-shrink-0"></i>
              <span class="text-sm font-medium mr-2 ml-2">View Status</span>
            </button>
            <button 
              (click)="commentEvent.emit(ticket)" 
              mat-menu-item 
              class="flex items-center justify-start gap-3 px-4 py-3 w-full hover:bg-blue-50 text-blue-600 hover:text-blue-800 transition-colors duration-200">
              <i class="fa-solid fa-comments text-blue-500 w-4 h-4 flex-shrink-0"></i>
              <span class="text-sm font-medium mr-2 ml-2">Comments</span>
            </button>
            <button 
              (click)="editEvent.emit(ticket)" 
              mat-menu-item 
              class="flex items-center justify-start gap-3 px-4 py-3 w-full hover:bg-green-50 text-green-600 hover:text-green-800 transition-colors duration-200">
              <i class="fa-solid fa-pen text-green-500 w-4 h-4 flex-shrink-0"></i>
              <span class="text-sm font-medium mr-2 ml-2">Edit</span>
            </button>
            <button 
              (click)="deleteEvent.emit(ticket)" 
              mat-menu-item 
              class="flex items-center justify-start gap-3 px-4 py-3 w-full hover:bg-red-50 text-red-600 hover:text-red-800 transition-colors duration-200">
              <i class="fa-solid fa-trash text-red-500 w-4 h-4 flex-shrink-0"></i>
              <span class="text-sm font-medium mr-2 ml-2">Delete</span>
            </button>
          </mat-menu>
        </td>

        <!-- Data Columns -->
        <td *ngFor="let col of columns" class="px-4 py-3 text-sm text-gray-900 text-wrap-break">
          <!-- Status Column with Dropdown -->
          <ng-container *ngIf="col.field === 'status'">
            <p-dropdown
              [(ngModel)]="ticket.status"
              [options]="statusOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Select Status"
              (onChange)="onStatusChange(ticket, $event.value)"
              [style]="{'width': '100%', 'min-width': '150px'}"
              [appendTo]="'body'"
              [autoZIndex]="true"
              [baseZIndex]="99999"
              [virtualScroll]="false"
              [filter]="false"
              styleClass="status-dropdown-cell">
            </p-dropdown>
          </ng-container>

          <!-- Priority Column with Badge -->
          <ng-container *ngIf="col.field === 'priority'">
            <span 
              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold"
              [ngClass]="getPriorityClass(ticket.priority)">
              {{ ticket.priority }}
            </span>
          </ng-container>

          <!-- Date Column -->
          <ng-container *ngIf="col.field === 'createdAt'">
            <span class="text-gray-600 font-mono">
              {{ formatDate(ticket.createdAt) }}
            </span>
          </ng-container>

          <!-- Regular Text Columns -->
          <ng-container *ngIf="col.field !== 'status' && col.field !== 'priority' && col.field !== 'createdAt'">
            <span class="text-gray-900 text-wrap">
              {{ ticket[col.field] }}
            </span>
          </ng-container>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="columns.length + 1" class="px-4 py-12 text-center">
          <div class="flex flex-col items-center justify-center space-y-6">
            <div class="relative">
              <div class="w-24 h-24 bg-gradient-to-br from-blue-100 to-indigo-200 rounded-full animate-pulse absolute inset-0"></div>
              <div class="w-24 h-24 bg-gradient-to-br from-blue-50 to-indigo-100 rounded-full flex items-center justify-center relative z-10 shadow-lg border-2 border-blue-200">
                <i class="pi pi-inbox text-blue-500 text-3xl animate-bounce"></i>
              </div>
            </div>
            <div class="space-y-3 max-w-md">
              <h5 class="text-xl font-bold text-gray-800">
                <span class="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                  No Records Found
                </span>
              </h5>
              <p class="text-gray-600 text-sm leading-relaxed">
                Your table is empty! Start by adding some data using the options above to see your records here.
              </p>
            </div>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

